import { Box, Flex, StyleSystemProps, TextV2, styled } from '@withjoy/joykit';
import { CSSObject } from '@withjoy/joykit/components/Box/Box.types';
import { ValuePropsSectionProps } from './ValuePropsSection';
import { pxToRem } from '@withjoy/joykit/theme';

export const StyledContainer = styled(Box)``;
export const StyledTitle = styled(TextV2)``;
export const StyledItemsContainer = styled(Box)``;
export const StyledItemContainer = styled(Flex)``;
export const StyledItemTitle = styled(TextV2)``;
export const StyledItemIcon = styled(Box)``;
export const StyledFlexItemsContainer = styled(Box)``;

const flexItemsContainerStyle = (variant: ValuePropsSectionProps['variant']): StyleSystemProps => ({
  display: variant === 'overview' ? ['grid', null, 'flex'] : 'flex',
  justifyContent: variant === 'overview' ? 'space-around' : 'space-between',
  rowGap: 6,
  gridTemplateColumns: '1fr 1fr',
  justifyItems: 'center',
});

const titleStyles = (variant: ValuePropsSectionProps['variant']): StyleSystemProps => ({
  typographyVariant: variant === 'overview' ? 'hed4' : ['hed4', null, 'hed5'],
  marginBottom:
    variant === 'overview'
      ? 7
      : {
          _: '32px',
          md: '34px',
        },
  textAlign: 'center',
});

const containerStyles = (variant: ValuePropsSectionProps['variant']): CSSObject => ({
  paddingY: variant !== 'overview' ? { _: '32px', md: '34px' } : undefined,
  marginX: variant !== 'overview' ? { _: '24px', md3: '102px', lg1: 'auto' } : undefined,
  marginBottom: variant !== 'overview' ? { xxs: '40px ', md: '108px' } : undefined, // same as curation hero header margin bottom
  width: 'fill-available',
  position: 'relative',
  maxWidth: '1440px',

  _before:
    variant !== 'overview'
      ? {
          position: 'absolute',
          content: '" "',
          height: '1px',
          width: '100%',
          top: 0,
          boxShadow: '0 -2px 0 0 #EBEBEB !important', // sometimes this is overridden with none from the joykit theme
        }
      : undefined,

  [`&:first-of-type`]:
    variant !== 'overview'
      ? {
          _before: {
            boxShadow: '0 -1px 0 0 #EBEBEB',
          },
        }
      : undefined,

  _after:
    variant !== 'overview'
      ? {
          position: 'absolute',
          content: '" "',
          height: '1px',
          width: '100%',
          bottom: '-1px',
          boxShadow: '0 -1px 0 0 #EBEBEB !important', // sometimes this is overridden with none from the joykit theme
        }
      : undefined,
});

const itemContainerStyles = (variant: ValuePropsSectionProps['variant'], link?: string): StyleSystemProps => ({
  width: variant === 'overview' ? pxToRem(95) : undefined,
  alignItems: 'center',
  flexDirection: variant === 'overview' ? 'column' : { _: 'column', md: 'row' },
  textAlign: variant === 'overview' ? 'center' : { _: 'center', md: 'left' },
  _hover: {
    color: 'mono11',
    _active: {
      color: '#000',
    },
  },
  cursor: link ? 'pointer' : 'default',
});

const itemTitleStyles = (variant: ValuePropsSectionProps['variant']): StyleSystemProps => ({
  typographyVariant: variant === 'overview' ? 'hed1' : ['hed1', null, 'hed3'],
  marginLeft: variant === 'overview' ? '0' : { _: '0', md: '19px' },
  marginTop: variant === 'overview' ? 4 : { _: '19px', md: '0' },
});

const itemIconStyles: StyleSystemProps = {
  height: '42px',
  display: 'flex',
  alignItems: 'center',
};

export const styles = {
  title: titleStyles,
  container: containerStyles,
  itemContainer: itemContainerStyles,
  itemTitle: itemTitleStyles,
  itemIcon: itemIconStyles,
  flexItemsContainer: flexItemsContainerStyle,
};
